import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    transformRequest,
    buildFormData,
    EXTERNAL_URL
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const { rawExternalApiBaseQuery: studentBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const osVersionCompatibilityAPI = createApi({
    baseQuery: studentBaseQuery,
    reducerPath: "osVersionCompatibilityAPI",
    endpoints: (builder) => ({
        addOsVersion: builder.mutation({
            query: (data) => ({
                url: "util/app/version",
                method: "POST",
                body: transformRequest ? transformRequest(data) : data,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getListOsVersion: builder.query({
            query: ({ page = 0, size = 10, searchText = "", sortDir = "desc", sortBy = "" } = {}) => ({
                url: `util/app/version/all`,
                method: "GET",
                params: {
                    page,
                    size,
                    ...(searchText && { searchText }),
                    ...(sortDir && { sortDir }),
                    ...(sortBy && { sortBy }),
                },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteOsVersion: builder.mutation({
            query: (id) => ({
                url: `util/app/version/${id}`,
                method: "DELETE",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

export const {
    useAddOsVersionMutation,
    useLazyGetListOsVersionQuery,
    useGetListOsVersionQuery,
    useDeleteOsVersionMutation,
} = osVersionCompatibilityAPI;

export default osVersionCompatibilityAPI;
